import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DndDropEvent } from 'ngx-drag-drop';
import { RoundsTags } from '../../../interfaces/rounds_tags';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-drop-tags',
  templateUrl: './drop-tags.component.html',
  styleUrl: './drop-tags.component.css'
})
export class DropTagsComponent {
  constructor(
    private snackBarService: MatSnackBar
  ) { }
  @Input()
  tagsAvailable: RoundsTags[] = [];
  @Output() onTagSelected=new EventEmitter<RoundsTags[]>();

  @Input()
  tagsSelected: RoundsTags[] = [];
  initMove: number;

  @Input() maxHeight:number=550;
  onDragStart(event: DragEvent, id: number) {
    console.log("Inicia start:", event);
    this.initMove = id;
    this.snackBarService.dismiss();
    let msg: string = (id == 1) ? "Agregando TAG" : "Retirando TAG";
    this.snackBarService.open(msg, undefined, { duration: 2000 });
  }

  onDrop(event: DndDropEvent, list: number) {
    console.log("EVENT:", event);
    console.log("DATA:", event.data);
    const data = event?.data as RoundsTags;

    if (list === 1 && this.initMove == 2) {

      // Mover elemento de tagsSelected a tagsAvailable
      this.tagsSelected = this.tagsSelected.filter(item => item.id !== data.id);
      this.tagsAvailable.push(data);      
      this.onTagSelected.emit(this.tagsSelected);

    } else if (list === 2 && this.initMove == 1) {

      // Mover elemento de tagsAvailable a tagsSelected
      this.tagsAvailable = this.tagsAvailable.filter(item => item.id !== data.id);
      if(!this.existsTagOnList(data?.id,this.tagsSelected)){
        this.tagsSelected.push(data);
        this.onTagSelected.emit(this.tagsSelected);
    
      }
    }
  }

//ultimas modificaciones
onDropTagsSelected(event: DndDropEvent) {
  if (!event.isExternal) {
    // Rearrange the tagsSelected array based on the drop event
    const data = event.data as RoundsTags;
    const index = event.index;
    const previousIndex = this.tagsSelected.findIndex(tag => tag.id === data.id);
    this.tagsSelected = this.moveItemInArray(this.tagsSelected, previousIndex, index);
    this.onTagSelected.emit(this.tagsSelected);
  }
}

moveItemInArray(arr: any[], fromIndex: number, toIndex: number) {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
}

  existsTagOnList(id: number, list: RoundsTags[]): boolean {
    return !!list.find(tag => tag?.id === id);
  }

}
